/**
 * DetailBackground component
 */
import AccentMask from '@components/atoms/mask/accentMask';
import Container from '@components/atoms/container/detailBackgroundContainer';
import DetailMask from '@components/atoms/mask/detailMask';
import VerticalMask from '@components/atoms/mask/verticalMask';

/**
 * This component displays the background and masks of the detail page.
 */
export default function DetailBackground() {
  return (
    <Container>
      <VerticalMask />
      <DetailMask />
      <AccentMask />
    </Container>
  );
}
